import {
    AwsCustomResource,
    AwsSdkCall,
    PhysicalResourceId,
} from 'aws-cdk-lib/custom-resources'
import { Construct } from 'constructs'
import * as iam from 'aws-cdk-lib/aws-iam'
import {Stack} from 'aws-cdk-lib'

export type AddApiStageToUsagePlanProps = Readonly<{
    UsagePlanId: string
    ApiId: string
    Stage: string
}>

/**
 * Attaches an API stage to a usage plan via a custom resource SDK call.
 * Workaround for missing L2 construct support.
 * @see https://github.com/aws/aws-cdk/discussions/22944#discussioncomment-6793333
 */
export const addApiStageToUsagePlan = (stack: Stack, name: string, props: AddApiStageToUsagePlanProps): Construct => {

    //implementation based on this ticket: https://github.com/aws/aws-cdk/discussions/22944#discussioncomment-6793333
    const usagePlanSdkCall = (op: string): AwsSdkCall => ({
        service: '@aws-sdk/client-api-gateway',
        action: 'UpdateUsagePlanCommand',
        parameters: {
            usagePlanId: props.UsagePlanId,
            patchOperations: [
                {
                    op,
                    path: '/apiStages',
                    value: `${props.ApiId}:${props.Stage}`,
                },
            ],
        },
        physicalResourceId: PhysicalResourceId.of(
            props.UsagePlanId + '--' + props.ApiId
        ),
    })

    return new AwsCustomResource(stack, name, {
        onCreate: usagePlanSdkCall('add'),
        onDelete: usagePlanSdkCall('remove'),
        installLatestAwsSdk: false,
        policy: {
            statements: [
                new iam.PolicyStatement({
                    resources: ['*'],
                    actions: ['apigateway:PATCH'],
                    effect: iam.Effect.ALLOW,
                }),
            ],
        },
    })
}
